import { postFinaliseResetCreditLimitRoute } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";
import { getLanguage } from "@utils/changeLanguage";
import { useState } from "react";

interface IFinalizeOrderResponse {
    success: boolean;
    orderNumber: string;
    paymentRef: string;
    file: {
        name: string;
        base64File: string;
    };
    prospectId: string;
}

export const useResetCreditLimit = () => {
    const [resetCreditLimitState, { post }] = useFetch();
    const lang = getLanguage();

    const finaliseResetCreditLimitPayment = (
        orderId: string,
        serviceId: number,
        finalisePaymentCallback: (data: IFinalizeOrderResponse) => void
    ) => {
        post<IFinalizeOrderResponse>(postFinaliseResetCreditLimitRoute(lang), {
            body: {
                orderId: orderId,
                serviceId: serviceId,
            },
        }).then((response) => {
            if (response) {
                finalisePaymentCallback(response);
            }
        });
    };

    return { resetCreditLimitState, finaliseResetCreditLimitPayment };
};
